document.addEventListener("turbolinks:load", () => {
  var playlistPlayer = null;
  var autoAdvanceEnabled = true; // Flag para controlar auto-advance
  
  // Make autoAdvanceEnabled globally accessible
  window.autoAdvanceEnabled = autoAdvanceEnabled;
  
  function initializePlaylistVideoPlayer() {
    if ($("#playlist-video-player").length > 0) {
      if (typeof window.ClipsPlayer !== 'undefined') {
        try {
          playlistPlayer = new window.ClipsPlayer({ selector: "#playlist-video-player" });
        } catch (error) {
          // Fallback to videojs
          if (typeof videojs !== 'undefined') {
            playlistPlayer = videojs("#playlist-video-player", {
              controls: true,
              responsive: true,
              fluid: true,
              playbackRates: [0.5, 1, 1.25, 1.5, 2]
            });
          }
        }
      } else {
        if (typeof videojs !== 'undefined') {
          playlistPlayer = videojs("#playlist-video-player", {
            controls: true,
            responsive: true,
            fluid: true,
            playbackRates: [0.5, 1, 1.25, 1.5, 2]
          });
        }
      }
      
      // Add ended event listener to show alert
      if (playlistPlayer) {
        addEndedEventListener();
      }
    }
    
    window.playlistPlayer = playlistPlayer;
  }
  
  function addEndedEventListener() {
    if (!playlistPlayer) return;
    
    // Remove existing ended listeners to prevent duplicates
    if (typeof playlistPlayer.off === 'function') {
      playlistPlayer.off('ended');
    }
    
    // Add ended event listener
    if (typeof playlistPlayer.on === 'function') {
      playlistPlayer.on('ended', function() {
        if (autoAdvanceEnabled) {
          advanceToNextClip();
        }
      });
    } else {
      // Try alternative approaches
      if (playlistPlayer.player && typeof playlistPlayer.player.on === 'function') {
        playlistPlayer.player.on('ended', function() {
          if (autoAdvanceEnabled) {
            advanceToNextClip();
          }
        });
      } else if (playlistPlayer.el && playlistPlayer.el.addEventListener) {
        playlistPlayer.el.addEventListener('ended', function() {
          if (autoAdvanceEnabled) {
            advanceToNextClip();
          }
        });
      }
    }
  }
  
  function advanceToNextClip() {
    // Find current playing clip
    var currentClipRow = $('.clickable-row').closest('tr.current-playing-clip');
    if (currentClipRow.length === 0) {
      return;
    }
    
    // Find next clip
    var nextClipRow = currentClipRow.next('tr').find('.clickable-row');
    if (nextClipRow.length === 0) {
      // Optionally loop back to first clip
      nextClipRow = $('.clickable-row').first();
      if (nextClipRow.length === 0) {
        return;
      }
    }
    
    // Get clip info
    var clipId = nextClipRow.data('clip-id');
    var clipType = nextClipRow.data('clip-type') || 'ObservationClip';
    
    if (clipId) {
      // Set a flag to auto-play after loading
      window.autoPlayAfterLoad = true;
      
      loadClipIntoPlayer(clipId, clipType);
    }
  }
  
  function toggleAutoAdvance() {
    autoAdvanceEnabled = !autoAdvanceEnabled;
    window.autoAdvanceEnabled = autoAdvanceEnabled; // Update global variable
    
    // Update UI to show current state
    var button = $('.auto-advance-toggle');
    if (button.length > 0) {
      if (autoAdvanceEnabled) {
        button.text(button.data('on-text')).removeClass('btn-secondary').addClass('btn-success');
      } else {
        button.text(button.data('off-text')).removeClass('btn-success').addClass('btn-secondary');
      }
    }
  }
  
  function cleanupPlaylistVideoPlayer() {
    if (window.playlistPlayer && typeof window.playlistPlayer.dispose === 'function') {
      window.playlistPlayer.dispose();
      window.playlistPlayer = null;
    }
  }
  
  function loadClipIntoPlayer(clipId, clipType) {
    var playlistId = window.location.pathname.split('/').pop();
    
    $.ajax({
      url: `/video_centre/playlists/${playlistId}/load_clip`,
      method: 'GET',
      data: {
        clip_id: clipId,
        clip_type: clipType || 'ObservationClip'
      },
      dataType: 'script',
      headers: {
        'Accept': 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript, */*; q=0.01'
      },
      error: function(xhr, status, error) {
        toastr.error('Error loading clip', '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      }
    });
  }

  function highlightFirstClip() {
    // Remove any existing highlights
    $('.clickable-row').closest('tr').removeClass('current-playing-clip');
    
    // Highlight the first clip in the table
    var firstClipRow = $('.clickable-row').first();
    if (firstClipRow.length > 0) {
      firstClipRow.closest('tr').addClass('current-playing-clip');
    }
  }

  function toggleVideoPlayback() {
    // Get the current player instance
    var player = window.playlistPlayer;
    
    if (player) {
      try {
        // Check if player has paused method (videojs)
        if (typeof player.paused === 'function') {
          if (player.paused()) {
            // Video is paused, start playing
            player.play();
          } else {
            // Video is playing, pause it
            player.pause();
          }
        } 
        // Check if player has pausePlayer method (ClipsPlayer)
        else if (typeof player.pausePlayer === 'function') {
          // For ClipsPlayer, we need to check the underlying videojs player
          if (player.player && typeof player.player.paused === 'function') {
            if (player.player.paused()) {
              player.player.play();
            } else {
              player.player.pause();
            }
          }
        }
        // Fallback: try to access the underlying videojs player directly
        else if (player.player && typeof player.player.paused === 'function') {
          if (player.player.paused()) {
            player.player.play();
          } else {
            player.player.pause();
          }
        }
      } catch (error) {
        // Silent error handling
      }
    }
  }
  
  // Only initialize playlist functionality on playlist show pages
  if (window.location.pathname.includes('/video_centre/playlists/') && 
      !window.location.pathname.endsWith('/video_centre/playlists')) {
    
    // Use setTimeout to ensure this runs after other scripts
    setTimeout(function() {
      // Remove any existing click handlers to prevent conflicts
      $('.clickable-row').off('click');
      $(document).off('click', '.clickable-row');
      
      // Add new click handler for playlist rows
      $(document).on('click', '.clickable-row', function(e) {
        // Prevent clicks on interactive elements
        if ($(e.target).closest('.share-icon, .favorite-icon, .disable-click-row, .dropdown, .btn, .edit-clip-icon').length > 0) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        // Prevent clicks on checkboxes
        if ($(e.target).hasClass('click-checkbox-vide-clip-icon') || $(e.target).is('input[type="checkbox"]')) {
          e.stopImmediatePropagation();
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var clipId = $(this).data('clip-id');
        var clipType = $(this).data('clip-type') || 'ObservationClip';
        
        if (clipId) {
          window.autoPlayAfterLoad = true;
          loadClipIntoPlayer(clipId, clipType);
        }
        
        return false;
      });

      // Add click handler for Play All button to toggle video playback
      $(document).on('click', '[data-target="#playlist-modal-new"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        toggleVideoPlayback();
        
        return false;
      });

      // Add keyboard shortcuts
      $(document).on('keydown', function(e) {
        // Don't handle shortcuts when typing in input fields
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
          return;
        }
        
        // Space bar to toggle play/pause
        if (e.keyCode === 32) {
          e.preventDefault();
          toggleVideoPlayback();
        }
        // Right arrow to next clip
        else if (e.keyCode === 39) {
          e.preventDefault();
          advanceToNextClip();
        }
        // A key to toggle auto-advance
        else if (e.keyCode === 65) {
          e.preventDefault();
          toggleAutoAdvance();
        }
      });

      // Highlight the first clip on page load
      highlightFirstClip();
      
      // Add click handler for remove clip button
      $(document).on('click', '.remove-clip-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $button = $(this);
        var clipId = $button.data('clip-id');
        var clipType = $button.data('clip-type');
        var playlistId = $button.data('playlist-id');
        
        // Show confirmation dialog
        if (confirm('Are you sure you want to remove this clip from the playlist?')) {
          $.ajax({
            url: `/video_centre/playlists/${playlistId}/remove_clip`,
            method: 'DELETE',
            data: {
              clip_id: clipId,
              clip_type: clipType
            },
            headers: {
              'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
              if (response.status === 'success') {
                // Remove the row from the table
                $button.closest('tr').fadeOut(400, function() {
                  $(this).remove();
                  
                  // Check if there are any clips left
                  if ($('.clickable-row').length === 0) {
                    // Show "no records found" message
                    var noRecordsRow = '<tr><td colspan="7">' + 'No clips found' + '</td></tr>';
                    $('tbody').append(noRecordsRow);
                  }
                });
                
                // Show success message
                toastr.success(response.message || 'Clip removed successfully', '', {
                  'closeButton': true,
                  'progressBar': true,
                  'positionClass': 'toast-top-center'
                });
              } else {
                toastr.error(response.message || 'Error removing clip', '', {
                  'closeButton': true,
                  'progressBar': true,
                  'positionClass': 'toast-top-center'
                });
              }
            },
            error: function(xhr, status, error) {
              var errorMessage = 'Error removing clip from playlist';
              if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMessage = xhr.responseJSON.message;
              }
              toastr.error(errorMessage, '', {
                'closeButton': true,
                'progressBar': true,
                'positionClass': 'toast-top-center'
              });
            }
          });
        }
        
        return false;
      });
    }, 100);
  }
  
  initializePlaylistVideoPlayer();
  
  // Cleanup on page unload
  $(window).on('beforeunload', cleanupPlaylistVideoPlayer);
  
  // Cleanup on turbo navigation
  $(document).on('turbo:before-visit', cleanupPlaylistVideoPlayer);
  
  // Make function globally available
  window.loadClipIntoPlayer = loadClipIntoPlayer;
  window.toggleVideoPlayback = toggleVideoPlayback;
  window.advanceToNextClip = advanceToNextClip;
  window.toggleAutoAdvance = toggleAutoAdvance;
});
